<li *ngFor="let hold of holds | map: holdMessagesToDisplay" class="vwmx-p100">
  {{ hold }}
</li>
